import { Link } from "react-router-dom";
import { ArrowRight, Phone, Zap } from "lucide-react";

/**
 * PricingConversionCTA — reusable conversion block rendered after each major
 * section of /pricing. Three primary actions: Book Now, Call Now, Get Instant Quote.
 * `scrollTarget="quote-widget"` on the third button lands the user on /book with
 * a scroll-to-widget query flag.
 */
export default function PricingConversionCTA({
  headline = "Ready To Get Your Exact Quote?",
  eyebrow = "Live Dispatch — 24/7",
  variant = "default", // "default" | "compact"
  testid = "pricing-conversion-cta",
}) {
  const isCompact = variant === "compact";
  return (
    <section
      data-testid={testid}
      className={`relative ${isCompact ? "py-10" : "py-16 md:py-20"}`}
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        {!isCompact && (
          <div className="text-[10px] uppercase tracking-[0.4em] text-[#C5A24A] mb-4">
            {eyebrow}
          </div>
        )}
        <h3
          className={`font-serif ${
            isCompact
              ? "text-2xl md:text-3xl"
              : "text-3xl md:text-4xl lg:text-5xl"
          } font-semibold tracking-tight text-white`}
        >
          {headline}
        </h3>
        {!isCompact && (
          <p className="mt-5 max-w-xl mx-auto text-sm md:text-base text-[#8E9AA6] font-light leading-relaxed">
            Every reservation is quoted flat at booking. No surge, no route surprises,
            no post-trip surcharges.
          </p>
        )}
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/book"
            data-testid={`${testid}-book`}
            className="inline-flex items-center gap-2 bg-white text-black hover:bg-[#E6E6E6] px-8 py-4 transition-all duration-300 font-medium text-xs tracking-[0.28em] uppercase"
          >
            Book Now <ArrowRight size={14} strokeWidth={1.5} />
          </Link>
          <a
            href="tel:+13475230763"
            data-testid={`${testid}-call`}
            className="inline-flex items-center gap-2 bg-transparent border border-white/30 text-white hover:bg-white hover:text-black px-8 py-4 transition-all duration-300 font-medium text-xs tracking-[0.28em] uppercase"
          >
            <Phone size={14} strokeWidth={1.5} /> Call Now
          </a>
          <Link
            to="/book?focus=quote-widget"
            data-testid={`${testid}-instant-quote`}
            className="inline-flex items-center gap-2 border border-[#C5A24A]/60 text-[#C5A24A] hover:bg-[#C5A24A] hover:text-black px-8 py-4 transition-all duration-300 font-medium text-xs tracking-[0.28em] uppercase"
          >
            <Zap size={14} strokeWidth={1.5} /> Get Instant Quote
          </Link>
        </div>
      </div>
    </section>
  );
}
